export const TNT_USER_PREFS_SCREEN_ID = "tnt_list";

export const TNT_LINKAGE_SELECTED_FILTERS_STORAGE_KEY =
  "scnc_tnt_linkage_selected_filters";

/** Default page size for `/api/v1/get_master_date` correction dropdowns. */
export const MASTER_DATA_PAGE_SIZE = 50;

/** UI field → `lookup_type` query param for `/api/v1/get_master_date`. */
export const MASTER_FIELD_TO_LOOKUP_TYPE = {
  siteCode: "site",
  vendorCode: "vendor",
  materialCode: "material",
};

/** Default confidence buckets on first load / reset (`confidence` query params). */
export const DEFAULT_CONFIDENCE_FILTER_VALUES = ["lt_60", "60_to_80"];

/** Display labels for known `/user-prefs` filter names (optional overrides only). */
export const TNT_PREF_NAME_LABEL_OVERRIDES = {
  unit_code: "Site Code",
  site_cluster: "Site Cluster",
  item_code: "Material Id",
  item_description: "Material Desc",
  vendor_name: "Vendor",
  Confidence: "Confidence",
  confidence: "Confidence",
  linkage_status: "Linkage Status",
  po_number: "PO Number",
  vendor_id: "Vendor Id",
  trip_id: "Trip Id",
  dispatchDate: "Dispatch Date",
  dispatchdate: "Dispatch Date",
  base_pack: "Base Pack",
  base_pack_description: "Base Pack Description",
  CBU: "CBU",
  cbu: "CBU",
  CBU_description: "CBU Description",
  cbu_description: "CBU Description",
  material_type: "Material Type",
  small_c: "Small C",
  material_group: "Material Group",
  material_group_description: "Material Group Description",
  week: "Week",
  vendorName: "T&T Vendor Name",
  destination:'T&T Destination',
  materialDesc :'T&T Material Desc',
  
};

/**
 * Internal filter key (normalized pref name) → `/tnt/get_filters` query param.
 * Unlisted keys are sent as-is.
 */
export const INTERNAL_FILTER_KEY_TO_API_PARAM = {
  unit_code: "site_code",
  item_code: "material_id",
  item_description: "material_desc",
  vendor_name: "vendor",
  materialdesc: "materialDesc",
  vendorname: "vendorName",
  dispatchdate: "dispatchDate",
  cbu: "CBU",
  cbu_description: "CBU_description",
};

/** `/tnt/get_filters` response key → internal filter key */
export const API_FILTER_PARAM_TO_INTERNAL_KEY = {
  site_code: "unit_code",
  material_id: "item_code",
  material_desc: "item_description",
  vendor: "vendor_name",
  materialDesc: "materialdesc",
  vendorName: "vendorname",
  dispatchDate: "dispatchdate",
  CBU: "cbu",
  CBU_description: "cbu_description",
  confidence: "confidence",
  linkage_status: "linkage_status",
  po_number: "po_number",
  site_cluster: "site_cluster",
  format: "format",
  bg: "bg",
  week: "week",
  vendor_id: "vendor_id",
  trip_id: "trip_id",
  destination: "destination",
  base_pack: "base_pack",
  base_pack_description: "base_pack_description",
  material_type: "material_type",
  buyers: "buyers",
  small_c: "small_c",
  material_group: "material_group",
  material_group_description: "material_group_description",
};

/** Legacy camelCase keys persisted before dynamic prefs rollout. */
export const LEGACY_FILTER_KEY_ALIASES = {
  siteCode: "unit_code",
  siteCluster: "site_cluster",
  materialId: "item_code",
  materialDesc: "item_description",
  vendor: "vendor_name",
  confidenceScore: "confidence",
  linkageStatus: "linkage_status",
  poNumber: "po_number",
};

export function normalizeTntFilterKey(name) {
  if (name == null || name === "") return "";
  const raw = String(name).trim();
  if (LEGACY_FILTER_KEY_ALIASES[raw]) return LEGACY_FILTER_KEY_ALIASES[raw];
  const n = raw.toLowerCase().replace(/[\s-]+/g, "_");
  if (LEGACY_FILTER_KEY_ALIASES[n]) return LEGACY_FILTER_KEY_ALIASES[n];
  return n || raw;
}

export function internalFilterKeyToApiParam(internalKey) {
  const key = normalizeTntFilterKey(internalKey);
  return INTERNAL_FILTER_KEY_TO_API_PARAM[key] ?? key;
}

export function apiFilterParamToInternalKey(apiKey) {
  if (apiKey == null || apiKey === "") return "";
  const raw = String(apiKey).trim();
  if (API_FILTER_PARAM_TO_INTERNAL_KEY[raw]) return API_FILTER_PARAM_TO_INTERNAL_KEY[raw];
  return normalizeTntFilterKey(raw);
}

export function buildEmptyTntFilterOptionsFromUserPrefs(userPrefsFilters) {
  const options = {};
  if (!Array.isArray(userPrefsFilters)) return options;
  for (const pf of userPrefsFilters) {
    const key = normalizeTntFilterKey(pf.name);
    if (key && !(key in options)) options[key] = [];
  }
  return options;
}

export function buildDefaultTntSelectedFilters(userPrefsFilters) {
  const filters = buildEmptyTntFilterOptionsFromUserPrefs(userPrefsFilters);
  if ("confidence" in filters) {
    filters.confidence = [...DEFAULT_CONFIDENCE_FILTER_VALUES];
  }
  return filters;
}
